import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TopicModel } from 'src/app/topic/@shared/topic.model';
import { fillSkeletonData } from 'src/app/@shared/app-helper';

@Component({
  // use onPush approach when performance is poor
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'topic-preview',
  standalone: false,
  styleUrls: ['./topic-preview.component.scss'],
  templateUrl: './topic-preview.component.html',
})
export class TopicPreviewComponent {
  @Input() public type: 'thumbnail' | 'avatar' | 'card';

  @Output() public openDetail: EventEmitter<TopicModel> = new EventEmitter<TopicModel>();

  public showSkeleton: boolean = true;
  public subheadline: string = this.getSkeletonSubheadline();

  // fill item with skeleton data
  // !!!IMPORTANT!!! always use a skeleton wrapper (<span class="skeleton">...</span>) around the value
  // to ensure skeleton text (single- as well as multiline) works as expected
  private _item: Partial<TopicModel> = {
    icd10Codes: [fillSkeletonData('icd')],
    synonyms: [fillSkeletonData('synonym')],
    title: fillSkeletonData('name'),
  };

  @Input()
  public get item(): TopicModel {
    return this._item as TopicModel;
  }

  public set item(item: TopicModel | null) {
    // item is initially null (skeleton)
    if (!item) {
      return;
    }

    this._item = item as Partial<TopicModel>;
    this.subheadline = [this.getSynonyms(), this.getIcd10Codes(), this.getIcd11Codes()].filter(Boolean).join(' · ');
    this.showSkeleton = false;
  }

  private getSynonyms(): string {
    return this.item?.synonyms?.filter(Boolean).join(', ') || '';
  }

  private getIcd10Codes(): string {
    const codes = this.item?.icd10Codes?.filter(Boolean).join(', ');

    return codes ? `ICD-10: ${codes}` : '';
  }

  private getIcd11Codes(): string {
    const codes = this.item?.icd11Codes?.filter(Boolean).join(', ');

    return codes ? `ICD-11: ${codes}` : '';
  }

  private getSkeletonSubheadline(): string {
    return [fillSkeletonData('synonym'), fillSkeletonData('icd')].join(' · ');
  }
}
